import SparkleImage from "../../assets/images/sparkle-icon.svg";

export default function AiAgentTitleTag(props: { name: string }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "4.44444px 8.88889px",
        gap: "4px",
        borderRadius: "17.7778px",
        background: "rgba(131, 126, 255, 0.25)",
        color: "#884EA6",
        whiteSpace: "nowrap",
        boxShadow:
          "0px 3.33333px 8.88889px rgba(131, 126, 255, 0.25), 0px 1.11111px 3.33333px rgba(131, 126, 255, 0.25), inset 0px 1.11111px 0px rgba(131, 126, 255, 0.08), inset 0px 0px 1.11111px rgba(131, 126, 255, 0.3)",
      }}
    >
      <img
        style={{ width: 20, marginRight: 6 }}
        src={SparkleImage}
      />

      {props.name}
    </div>
  );
}
